<template>
  <div class="flex w-full h-full">
    <slot />
  </div>
</template>
